export const convertToHoursMinutes = (time: number | string) => {
  const hours: number | string = time ? `${time}`.split('.')[0] : 0;
  const minutes: number | string = time ? parseFloat(`${time}`.split('.')[1]) % 60 : 0;

  return `${hours}h ${minutes}m`;
};
